import { useState } from "react";
import { Title } from "react-migration/domains/ownership";
import { Button } from "@landtechnologies/components";
import { useTranslation } from "react-migration/lib";
import { PropertyUnits } from "../../PropertyUnits";
import { SingleTitleOwnershipInformation } from "./SingleTitleOwnershipInformation";

type Props = {
  titlesByLocation: Title[];
  titlesByLocationLoading: boolean;
};

export const MultiTitleOwnershipInformation = ({
  titlesByLocation,
  titlesByLocationLoading,
}: Props) => {
  const [selectedPropertyUnit, setSelectedPropertyUnit] = useState<Title | null>(null);
  const { t } = useTranslation();

  return (
    <div data-testid="multi-title-ownership-information">
      {!selectedPropertyUnit && (
        <PropertyUnits
          titlesByLocation={titlesByLocation}
          titlesByLocationLoading={titlesByLocationLoading}
          setUnitInfo={(property) => setSelectedPropertyUnit(property as Title)}
        />
      )}

      {selectedPropertyUnit && (
        <>
          <div
            className="atlas-flex atlas-flex-start atlas-pb-4"
            data-testid="back-button-container"
          >
            <Button.Secondary
              className="atlas-border-none atlas-items-center"
              onClick={() => setSelectedPropertyUnit(null)}
            >
              <i className="icon-lt-arrow-left-s-line atlas-mr-1" />
              <span>{t("sites.card.ownership.back")}</span>
            </Button.Secondary>
          </div>
          <SingleTitleOwnershipInformation titlesByLocation={[selectedPropertyUnit]} />
        </>
      )}
    </div>
  );
};
